
















import { IFilm } from "@/@types/cinema/films";
import { Component, Prop, Vue } from "vue-property-decorator";
import { IFilmCategory as ICat } from "@/@types/cinema/film-category";

import ChangeFilmForm from "@/components/forms/cinema/change-film-form.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({ components: { StandartModal, ChangeFilmForm } })
export default class ChangeMovieForm extends Vue {
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICat>;
  @Prop({ type: Object, default: null }) movie!: IFilm | null;

  $refs!: { "change-film-form": ChangeFilmForm };

  updateMovie(id: string, data: Partial<IFilm>): void {
    this.$emit("updateMovie", id, data);
  }

  resetForm(): void {
    this.$refs["change-film-form"].onReset();
  }
}
